var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_25",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("defs", [
        _c("clipPath", { attrs: { id: "clippath" } }, [
          _c("rect", {
            staticStyle: { fill: "none", "stroke-width": "0px" },
            attrs: {
              x: "33.493",
              y: "21.472",
              width: "33.013",
              height: "67.429",
            },
          }),
        ]),
      ]),
      _c("g", { staticStyle: { "clip-path": "url(#clippath)" } }, [
        _c("path", {
          staticStyle: { "fill-rule": "evenodd", "stroke-width": "0px" },
          attrs: {
            d: "m33.917,36.658c.37-2.698.976-5.453,1.751-8.187.468-1.652.971-3.197,1.473-4.591.176-.489.34-.926.488-1.303.089-.229.154-.389.19-.475.159-.381.53-.629.943-.629h22.476c.413,0,.785.248.943.629.036.086.101.246.19.475.147.377.312.814.488,1.303.502,1.395,1.004,2.939,1.473,4.591.775,2.734,1.38,5.489,1.75,8.187.413,3.007.517,5.831.259,8.414-.128,1.281-.405,2.717-.866,4.628-.246,1.018-1.23,4.825-1.373,5.397-.899,3.588-1.477,6.428-1.85,9.411-.26,2.077-.408,4.617-.459,7.516-.058,3.299.012,6.841.164,10.322.04.921.083,1.766.127,2.517.026.449.046.767.058.943.099,1.702-1.226,3.095-2.937,3.095h-18.408c-1.708,0-3.031-1.407-2.935-3.122.011-.166.031-.483.057-.931.043-.749.086-1.593.126-2.513.152-3.482.222-7.024.163-10.325-.051-2.892-.199-5.428-.459-7.502-.373-2.984-.952-5.819-1.851-9.405-.136-.543-1.124-4.366-1.371-5.391-.461-1.911-.738-3.351-.867-4.64-.258-2.583-.154-5.407.259-8.414h0Zm28.449-7.63c-.455-1.605-.942-3.104-1.429-4.456-.14-.389-.272-.742-.393-1.056h-21.088c-.121.314-.253.667-.393,1.056-.487,1.352-.975,2.851-1.43,4.456-.639,2.255-1.158,4.521-1.518,6.747h27.769c-.36-2.226-.879-4.493-1.519-6.747h0Zm-26.537,8.791c-.297,2.525-.353,4.891-.138,7.05.118,1.178.379,2.536.82,4.364.243,1.006,1.228,4.816,1.368,5.373.918,3.66,1.511,6.57,1.896,9.649.269,2.156.422,4.76.474,7.719.059,3.348-.011,6.931-.165,10.45-.04.929-.084,1.782-.128,2.541-.026.456-.046.78-.058.941-.03.534.364.953.896.953h18.408c.539,0,.928-.408.898-.923-.012-.174-.032-.498-.058-.955-.044-.76-.087-1.614-.128-2.545-.154-3.519-.224-7.1-.166-10.446.052-2.966.204-5.575.474-7.734.385-3.078.979-5.993,1.896-9.654.147-.587,1.128-4.382,1.369-5.381.442-1.828.702-3.182.819-4.352.216-2.158.159-4.525-.138-7.05h-28.341Zm21.834,8.173c-.846,0-1.533-.686-1.533-1.533s.686-1.533,1.533-1.533,1.533.686,1.533,1.533-.686,1.533-1.533,1.533Zm-13.281,2.043c-.847,0-1.533-.686-1.533-1.533s.686-1.533,1.533-1.533,1.532.686,1.532,1.533-.686,1.533-1.532,1.533Zm8.173,8.173c-.847,0-1.533-.686-1.533-1.533s.686-1.533,1.533-1.533,1.532.686,1.532,1.533-.686,1.533-1.532,1.533Zm-6.13,9.195c-.846,0-1.533-.686-1.533-1.533s.686-1.533,1.533-1.533,1.533.686,1.533,1.533-.686,1.533-1.533,1.533Zm6.13,11.238c-.847,0-1.533-.686-1.533-1.533s.686-1.533,1.533-1.533,1.532.686,1.532,1.533-.686,1.533-1.532,1.533Z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }